import { motion } from "framer-motion";
import { Sparkles, Clock } from "lucide-react";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";

const TrialBanner = ({ sub }) => {
  const navigate = useNavigate();

  if (!sub || sub.subscription_status !== "trial") return null;

  const daysLeft = sub.days_remaining ?? 0;
  const urgent = daysLeft <= 2;

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className={`mb-8 border ${
        urgent ? "border-orange-500/40 bg-orange-500/5" : "border-primary/30 bg-primary/5"
      } p-4 md:p-5 flex flex-col md:flex-row md:items-center justify-between gap-4`}
      data-testid="trial-banner"
    >
      <div className="flex items-center gap-3">
        <div
          className={`w-10 h-10 flex items-center justify-center rounded-full ${
            urgent ? "bg-orange-500/20" : "bg-primary/15"
          }`}
        >
          <Clock className={`w-5 h-5 ${urgent ? "text-orange-500" : "text-primary"}`} />
        </div>
        <div>
          <p className="font-semibold text-foreground">
            {daysLeft > 0
              ? `${daysLeft} day${daysLeft === 1 ? "" : "s"} left in your free trial`
              : "Your trial ends today"}
          </p>
          <p className="text-sm text-muted-foreground">
            Continue training for £{sub.monthly_price_gbp}/month — or join Memory School for full access.
          </p>
        </div>
      </div>
      <Button
        onClick={() => navigate("/paywall")}
        data-testid="trial-banner-upgrade-btn"
        className="bg-primary text-primary-foreground hover:bg-primary/90"
      >
        <Sparkles className="w-4 h-4 mr-2" />
        Upgrade now
      </Button>
    </motion.div>
  );
};

export default TrialBanner;
